import React from 'react';
import { Dialog, Image, T, useTranslation } from '@colonist/ui';
import { RUSH_RULES_YOUTUBE_EMBED_URL, RUSH_RULES_YOUTUBE_VIDEO_URL } from '@colonist/consts';
import { emptyTranslation } from '@colonist/i18n';
import IconRushInfo from '@static/images/icon_rushinfo.svg';
import IconPassTurn from '@static/images/icon_pass_turn.svg';
import IconSettlementGold from '@static/images/settlement_gold.svg';
import IconDice4 from '@static/images/dice_4.svg';
import IconRobber from '@static/images/icon_robber.svg';
import styles from './RushRulesDialog.module.scss';
import { RUSH_RULES_PLACEHOLDER_IMAGE_SRC } from './constants.ts';
const DECORATIVE = emptyTranslation;
const RUSH_RULES_FACTS = [
    {
        icon: {
            src: IconPassTurn,
            alt: DECORATIVE
        },
        text: {
            key: 'strings:popups.rushRules.fact1'
        }
    },
    {
        icon: {
            src: IconSettlementGold,
            alt: DECORATIVE
        },
        text: {
            key: 'strings:popups.rushRules.fact2'
        }
    },
    {
        icon: {
            src: IconDice4,
            alt: DECORATIVE
        },
        text: {
            key: 'strings:popups.rushRules.fact3'
        }
    },
    {
        icon: {
            src: IconRobber,
            alt: DECORATIVE
        },
        text: {
            key: 'strings:popups.rushRules.fact4'
        }
    }
];
/** Rush rules dialog. */ export const RushRulesDialog = ({ open, showVideo, onExternalClick, onClose, onConfirm })=>{
    const { t } = useTranslation();
    const onPlaceholderClick = ()=>{
        onExternalClick(RUSH_RULES_YOUTUBE_VIDEO_URL);
    };
    return /*#__PURE__*/ React.createElement(Dialog, {
        open: open,
        onClose: onClose,
        size: "sm"
    }, /*#__PURE__*/ React.createElement(Dialog.Title, null, /*#__PURE__*/ React.createElement("span", {
        className: styles.titleRow
    }, /*#__PURE__*/ React.createElement(Image, {
        className: styles.titleIcon,
        image: {
            src: IconRushInfo,
            alt: DECORATIVE
        }
    }), /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:popups.rushRules.title'
        }
    }))), /*#__PURE__*/ React.createElement(Dialog.Content, null, /*#__PURE__*/ React.createElement("div", {
        className: styles.content
    }, showVideo && /*#__PURE__*/ React.createElement("iframe", {
        className: styles.video,
        src: RUSH_RULES_YOUTUBE_EMBED_URL,
        title: t('strings:popups.rushRules.videoTitle'),
        allowFullScreen: true
    }), !showVideo && /*#__PURE__*/ React.createElement(Image, {
        className: styles.placeholder,
        image: {
            src: RUSH_RULES_PLACEHOLDER_IMAGE_SRC,
            alt: 'strings:popups.rushRules.videoTitle'
        },
        onClick: onPlaceholderClick
    }), /*#__PURE__*/ React.createElement("ul", {
        className: styles.factList
    }, RUSH_RULES_FACTS.map((fact)=>/*#__PURE__*/ React.createElement("li", {
            key: fact.text.key,
            className: styles.factItem
        }, /*#__PURE__*/ React.createElement(Image, {
            className: styles.factIcon,
            image: fact.icon
        }), /*#__PURE__*/ React.createElement("span", null, /*#__PURE__*/ React.createElement(T, {
            id: fact.text
        }))))))), /*#__PURE__*/ React.createElement(Dialog.ButtonFooter, null, /*#__PURE__*/ React.createElement(Dialog.ButtonFooter.ConfirmButton, {
        onClick: onConfirm
    }, /*#__PURE__*/ React.createElement(T, {
        id: {
            key: 'strings:popups.rushRules.startGame'
        }
    }))));
};
